export default __webpack_public_path__ + "static/media/i-scan_connect.8472ccf3.svg";